import script from "./RoutingIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutingIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__